import {PaymentCurrencyType} from "@irati/types"
import {useOnce} from "@irati/utils/hooks/useOnce"
import {useFlexiPointsExpiryQuery} from "@irati/wallet/hooks/wallet"
import {daysLeft, pointsExpiryVariables} from "@irati/wallet/helpers/expiry"
import moment from "moment"

export const useFlexiPointsWalletExpired = (walletId: string) => {
  const args = useOnce(() => pointsExpiryVariables(walletId, PaymentCurrencyType.Rp))
  const {data: expiredFlexiPoints, ...apollo} = useFlexiPointsExpiryQuery(args)

  const hasExpiry = !!expiredFlexiPoints?.total

  if (hasExpiry) {
    const expiresAt = expiredFlexiPoints?.breakdown?.[0]?.expiresAt
    return {
      ...apollo,
      expiry: {
        hasExpiry: true,
        expiresAt,
        date: moment(expiresAt).format("DD/MM/YY"),
        amount: expiredFlexiPoints?.breakdown?.[0]?.amount!,
        daysLeft: daysLeft(expiresAt ?? "")
      }
    } as const
  }

  return {
    ...apollo,
    expiry: {
      hasExpiry: false
    }
  } as const
}
